import React, { useState, useEffect, useRef } from "react";
import "./Companydetails.scss";
import Edit from "../../images/CompanyEdit.svg";
import axios from "axios";
import { Route, Navigate, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import companylogo from '../../images/person.png';
import ImageComponent from "../../components/Image/CompamyImage";
import defaultLogo from '../../images/default_logo.jpg';
import { ToastContainer, toast } from 'react-toastify';
import { Details } from "@mui/icons-material";

function Companydetails() {

  const [companyDetails, setCompanyDetails] = useState(null);
  const [licenseDetails, setLicenseDetails] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const { te_companyid, te_lmsid } = useParams();
  const [editable, setEditable] = useState(false);
  const [editedData, setEditedData] = useState({});
  const navigate = useNavigate();
  const [userAdminDetails, setUserAdminDetails] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});


  useEffect(() => {

    const fetchCompanyDetails = async () => {
      try {
        const response = await axios.get('/v1/companyprofile/listbyid/' + te_companyid,
          {
            headers: {
              'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
            }
          });
        if (response.status === 200) {
          setCompanyDetails(response.data.data);
          setCompanyName(response.data.data.te_companyname);
          console.log("companyDetails", response.data.data.te_companylogosmall)
          console.log("companyDetails", companyDetails.te_companylogosmall)
          // console.log("response.data.data",response.data.data)
        } else {
          console.error("Failed to fetch license details");
        }
      } catch (error) {
        console.error("Error fetching license details:", error);
      }
    };

    fetchCompanyDetails();
  }, [te_companyid]);

  const [te_userid, setTeUserId] = useState(null);
  useEffect(() => {
    const fetchUserAdminDetails = async () => {
      try {
        const response = await axios.get(`/v1/companyprofile/getCompanyAdmin/${te_companyid}`, {
          headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
          }
        });

        console.log(response.data.data)
        if (response.status === 200) {
          setUserAdminDetails(response.data.data);
          setTeUserId(response.data.data.te_userid);
          console.log(te_userid)
        } else {
          console.error("Failed to fetch user admin details");
        }
      } catch (error) {
        console.error("Error fetching user admin details:", error);
      }
    };
    fetchUserAdminDetails();
  }, [te_companyid]);




  useEffect(() => {
    const fetchLicenseDetails = async () => {
      try {
        const response = await axios.get('/v1/licensedetails/listbyid/' + te_lmsid,
          {
            headers: {
              'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
            }
          });
        if (response.status === 200) {
          setLicenseDetails(response.data.data);
        } else {
          console.error("Failed to fetch license details");
        }
      } catch (error) {
        console.error("Error fetching license details:", error);
      }
    };
    fetchLicenseDetails();
  }, [te_lmsid]);






  const formatDate = (dateString) => {
    if (!dateString) {
      return "";
    }
    const date = moment.utc(dateString).format('DD-MMM-YYYY');
    if (date === "Invalid date") {
      return "";
    }
    return date;
  };


  const handleEdit = () => {
    if (companyDetails) {
      setEditedData({
        te_companyname: companyName,
        te_customername: companyDetails.te_customername,
        te_companyurladdress: companyDetails.te_companyurladdress,
        te_companyphonenumber: companyDetails.te_companyphonenumber,
        te_companyemail: companyDetails.te_companyemail,
        te_companyaddress: companyDetails.te_companyaddress
      });
      setEditable(!editable);
    }
  };

  const [invalidFields, setInvalidFields] = useState({});

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setEditedData(prevState => ({
  //     ...prevState,
  //     [name]: value
  //   }));
  //   if (value.trim() === '') {
  //     console.log("invalidFields",invalidFields.length)
  //     setInvalidFields({ ...invalidFields, [name]: true });
  //   } else {
  //     setInvalidFields({ ...invalidFields, [name]: false });
  //     console.log("invalidFields",invalidFields)
  //   }
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim(); // Trim leading and trailing spaces
    setEditedData(prevState => ({
      ...prevState,
      [name]: trimmedValue
    }));
  
    // Clear existing validation errors for this field
    setValidationErrors(prev => ({ ...prev, [name]: null }));
  
    if (trimmedValue === '') {
      setInvalidFields(prev => ({ ...prev, [name]: true }));
    } else {
      setInvalidFields(prev => ({ ...prev, [name]: false }));
  
      if (name === 'te_companyemail') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
        if (!emailPattern.test(trimmedValue)) {
          setValidationErrors(prev => ({ ...prev, [name]: "Invalid email address" }));
        } else {
          setValidationErrors(prev => ({ ...prev, [name]: null }));
        }
      }
  
      if (name === 'te_companyphonenumber') {
        const phonePattern = /^\+?\d*$/;
        if (!phonePattern.test(trimmedValue)) {
          setValidationErrors(prev => ({ ...prev, [name]: "Invalid phone number" }));
        } else {
          setValidationErrors(prev => ({ ...prev, [name]: null }));
        }
        console.log(`Phone validation for '${trimmedValue}': ${phonePattern.test(trimmedValue)}`);
      }
  
      if (name === 'te_companyurladdress') {
        const urlPattern = /^(ftp|http|https):\/\/[^\s$.?#].[^\s]*$/i;
        if (!urlPattern.test(trimmedValue)) {
          setValidationErrors(prev => ({ ...prev, [name]: "Invalid URL format" }));
        } else {
          setValidationErrors(prev => ({ ...prev, [name]: null }));
        }
      }
    }
  };
  


  const prepareDataForUpdate = () => {
    const { te_companyurladdress, te_companyaddress, te_companyemail, te_companyphonenumber, te_customername } = editedData;

 
    const dataToSend = {
      "companyname": companyName,
      "companyurl": editedData.te_companyurladdress,
      "companyaddress": editedData.te_companyaddress,
      "companyemail": editedData.te_companyemail,
      "companynumber": editedData.te_companyphonenumber,
      "companycountrycode": '+91',
      "customername": editedData.te_customername
    };
    console.log("dataToSend", dataToSend)
    return dataToSend;
  };

  

  const handleSave = async () => {
    const requiredFields = [
      'te_companyname', 'te_companyurladdress', 'te_customername', 'te_companyemail', 'te_companyphonenumber'
    ];
  
    const hasInvalidFields = requiredFields.some(field => editedData[field]?.trim() === '');
    // Check for any validation errors
    const hasValidationErrors = Object.keys(validationErrors).some(key => validationErrors[key]);
  
    if (hasInvalidFields || hasValidationErrors) {
      console.error("Please fill all required fields correctly");
      return;
    }
    const dataToSend = prepareDataForUpdate();

    try {
      const response = await axios.put(`/v1/companyprofile/update/${te_companyid}`, dataToSend, {
        headers: {
          'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
        }
      });
      if (response.status === 200) {
        setCompanyDetails(editedData);
        setEditable(false);
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
      });
      } else {
        console.error("Failed to update company details");
      }
    } catch (error) {
      console.error("Error updating company details:", error);
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    }
  };

  const [editableSPOC, setEditableSPOC] = useState(false);
  const [editedSPOCData, setEditedSPOCData] = useState({});
  const handleSPOCEdit = () => {
    if (userAdminDetails) {
      setEditedSPOCData({
        te_username: userAdminDetails.te_username || '',
        te_phone: userAdminDetails.te_phone || '',
        te_useremail: userAdminDetails.te_useremail || '',
      });
      setEditableSPOC(!editableSPOC);
    }
  };

  // const handleChangeSPOC = (e) => {
  //   const { name, value } = e.target;
  //   setEditedSPOCData((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  //   if (value.trim() === '') {
  //     setInvalidFieldsSPOC({ ...invalidFieldsSPOC, [name]: true });
  //   } else {
  //     setInvalidFieldsSPOC({ ...invalidFieldsSPOC, [name]: false });
  //   }
  // };
  const handleChangeSPOC = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim(); // Trim leading and trailing spaces
    setEditedSPOCData(prevState => ({
      ...prevState,
      [name]: trimmedValue
    }));
    
    // Clear existing validation errors for this field
    setValidationErrors(prev => ({ ...prev, [name]: null }));
    
    if (trimmedValue === '') {
      setInvalidFieldsSPOC(prev => ({ ...prev, [name]: true }));
    } else {
      setInvalidFieldsSPOC(prev => ({ ...prev, [name]: false }));
      
      if (name === 'te_useremail') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
        if (!emailPattern.test(trimmedValue)) {
          setValidationErrors(prev => ({ ...prev, [name]: "Invalid email address" }));
        } else {
          setValidationErrors(prev => ({ ...prev, [name]: null }));
        }
      }
  
      if (name === 'te_phone') {
        const phonePattern = /^\+?\d*$/;
        if (!phonePattern.test(trimmedValue)) {
          setValidationErrors(prev => ({ ...prev, [name]: "Invalid phone number" }));
        } else {
          setValidationErrors(prev => ({ ...prev, [name]: null }));
        }
      }
    }
  };
  

  const [invalidFieldsSPOC, setInvalidFieldsSPOC] = useState({});

  const handleSPOCSave = async () => {
    const requiredFieldsSPOC = ['te_username', 'te_phone', 'te_useremail'];

    const hasInvalidFieldsSPOC = requiredFieldsSPOC.some(
      (field) => editedSPOCData[field]?.trim() === ''
    );
  
    // Check for validation errors
    const hasValidationErrorsSPOC = Object.keys(validationErrors).some(
      key => validationErrors[key]
    );
  
    if (hasInvalidFieldsSPOC || hasValidationErrorsSPOC) {
     
      console.error("Please fill all required fields correctly");
      return;
    }
    const dataToSend = {
      username: editedSPOCData.te_username,
      phone: editedSPOCData.te_phone,
      email: editedSPOCData.te_useremail,
      firstname: editedSPOCData.te_username,
      lastname: editedSPOCData.te_username,
      usertype: "platform",
      divisionid: "1",
      roleid: "87",
      te_useractivatedat:licenseDetails.te_licenseactivationdate,
      te_userdeactivatedat:licenseDetails.te_licenseexpirationdate
    };

    try {
      const response = await axios.put(
        `/v1/cmsuser/update/${te_userid}`,
        dataToSend,
        {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("access_token"),
          },
        }
      );
      if (response.status === 200) {
        setUserAdminDetails(editedSPOCData);
        setEditableSPOC(false);
       if(response.data.message ==="CMS USER UPDATED SUCCESSFULLY"){
        toast.success("SPOC Details updated Successfully" , {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
      });
    }
    else{
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    }
      } else {
        console.error("Failed to update SPOC details");
        
      }
    } catch (error) {
      console.error("Error updating SPOC details:", error);
      toast.error(error.response.data.data, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    }
  };

  const calculateValidDays = () => {
    if (!licenseDetails || !licenseDetails.te_licenseactivationdate || !licenseDetails.te_licenseexpirationdate) {
      return "";
    }
    const activationDate = moment.utc(licenseDetails.te_licenseactivationdate);
    const expirationDate = moment.utc(licenseDetails.te_licenseexpirationdate);
    const validDays = expirationDate.diff(activationDate, 'days')+1;
    return validDays;
  };
  return (
    <div className="CompanyList">
      <div className='CompanyDetails'>
        <div className='top-grid'>
          <div className='grid-1'>
            <div className="heading">Company Details
              <img className="edit-icon"
                src={Edit} onClick={handleEdit} />
            </div>
            <table class="table-company">
              <tbody className='table-body'>
                <tr >
                  <th>
                    <div className="image-container">
                      {/* <img className="image-logo" src={companylogo} alt="Red Bull Logo" /> */}
                      {companyDetails && companyDetails.te_companylogosmall ? (
                        <>
                          <ImageComponent image={companyDetails ? companyDetails.te_companylogosmall : ""} />

                        </>
                      ) : (

                        <img className="image-logo" src={defaultLogo} alt="Default Logo" />

                      )}

                    </div>
                  </th>
                  <td>
                    <div className="company-name-container">
                      <span>Company Name</span>
                      {editable ? (
                        <input
                          type="text"
                          id="customername"
                          name="te_customername"
                          value={editedData.te_companyname}
                          onChange={handleChange}
                          className={invalidFields.te_companyname ? 'invalid' : ''}
                          readOnly
                        />
                      ) : (
                        <span>{companyDetails ? companyDetails.te_companyname : ""}</span>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>Customer</th>
                  <td>
                    {editable ?
                      <input type="text" id="customername"
                        name="te_customername" value={editedData.te_customername} onChange={handleChange} 
                        className={invalidFields.te_customername ? 'invalid' : ''}/>
                      : companyDetails ? companyDetails.te_customername : ""}
                  </td>
                </tr>
                <tr>
                  <th>Company URL</th>
                  <td>
                    {editable ?
                    <div>
                      <input type="url" id="companyaddress"
                        name="te_companyurladdress" value={editedData.te_companyurladdress} onChange={handleChange} 
                        className={invalidFields.te_companyurladdress ? 'invalid' : ''}/>
                        {validationErrors.te_companyurladdress && (
                          <div className="error-message">{validationErrors.te_companyurladdress}</div>
                        )}
                        </div>
                      : companyDetails ? companyDetails.te_companyurladdress : ""}
                  </td>
                </tr>
                <tr>
                  <th>Contact Details</th>
                  <td>
                    {editable ?
                    <div>
                      <input type="tel" id="companynumber"
                        name="te_companyphonenumber" value={editedData.te_companyphonenumber} onChange={handleChange} 
                        className={invalidFields.te_companyphonenumber ? 'invalid' : ''}/>
                        {validationErrors.te_companyphonenumber && (
                          <div className="error-message">{validationErrors.te_companyphonenumber}</div>
                        )}
                        </div>
                      : companyDetails ? companyDetails.te_companyphonenumber : ""}
                  </td>
                </tr>
                <tr>
                  <th>Email ID</th>
                  <td>
                    {editable ?
                     <div>
                      <input 
                      type="email" 
                      id="companyemail"
                        name="te_companyemail" 
                        value={editedData.te_companyemail} 
                        onChange={handleChange} 
                        className={invalidFields.te_companyemail ? 'invalid' : ''}
                        />
                        {validationErrors.te_companyemail && (
                          <div className="error-message">{validationErrors.te_companyemail}</div>
                        )}
                        </div>
                      : companyDetails ? companyDetails.te_companyemail : ""}
                  </td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td>
                    {editable ?
                      <input type="text" id="companyaddress"
                        name="te_companyaddress" value={editedData.te_companyaddress} onChange={handleChange} 
                        className={invalidFields.te_companyaddress ? 'invalid' : ''}/>
                      : companyDetails ? companyDetails.te_companyaddress : ""}
                  </td>
                </tr>
              </tbody>

            </table>
            {editable &&
              <button className="update-button" onClick={handleSave}>Update</button>
            }
          </div>
          <div className='grid-2'>
           
            <div className="heading">
              SPOC Details
              <img
                className="edit-icon"
                src={Edit}
                onClick={handleSPOCEdit}
              />
            </div>
           
            <table class="table-company">
              <tbody className='table-body'>
                <tr>
                  <th>Name</th>
                  <td>
                    {editableSPOC ? (
                      <input
                        type="text"
                        name="te_username"
                        value={editedSPOCData.te_username}
                        onChange={handleChangeSPOC}
                        className={invalidFieldsSPOC.te_username ? 'invalid' : ''}
                      />
                    ) : (
                      userAdminDetails ? userAdminDetails.te_username : ""
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Role</th>
                  <td>Admin</td>
                </tr>
                <tr>
                  <th>Mobile Number</th>
                  <td>
                    
                    {editableSPOC ? (
                      <div>
                      <input
                        type="tel"
                        name="te_phone"
                        value={editedSPOCData.te_phone}
                        onChange={handleChangeSPOC}
                        className={invalidFieldsSPOC.te_phone ? 'invalid' : ''}
                      />
                      {validationErrors.te_phone && (
                        <div className="error-message">{validationErrors.te_phone}</div>
                      )}
                      </div>
                    ) : (
                      userAdminDetails ? userAdminDetails.te_phone : ""
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Email ID</th>
                  <td>
                    {editableSPOC ? (
                      <div>
                      <input
                        type="email"
                        name="te_useremail"
                        value={editedSPOCData.te_useremail}
                        onChange={handleChangeSPOC}
                        className={invalidFieldsSPOC.te_useremail ? 'invalid' : ''}
                      />
                      {validationErrors.te_useremail && (
                        <div className="error-message">{validationErrors.te_useremail}</div>
                      )}
                      </div>
                    ) : (
                      userAdminDetails ? userAdminDetails.te_useremail : ""
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Activation Date</th>
                  <td>{licenseDetails ? formatDate(licenseDetails.te_licenseactivationdate) : ''}</td>
                </tr>
                <tr>
                  <th>Deactivation Date </th>
                  <td>{licenseDetails ? formatDate(licenseDetails.te_licenseexpirationdate) : ''}</td>
                </tr>

              </tbody>
            </table>
            {editableSPOC && (
              <button className="update-button" onClick={handleSPOCSave}>Update</button>
            )}
          </div>
          <div className='grid-3'>
            <div className="heading">Payment Details<img className="edit-icon" src={Edit} /></div>
            <table class="table-company">
              <tbody className='table-body'>
                <tr>
                  <th>Amount</th>
                  <td>1</td>
                </tr>
                <tr>
                  <th>Invoice No</th>
                  <td>Sample Bundle</td>
                </tr>
                <tr>
                  <th>Date</th>
                  <td>5</td>
                </tr>
                <tr>
                  <th>Pay Mode</th>
                  <td>2024-03-20</td>
                </tr>
                <tr>
                  <th>Cheque No</th>
                  <td>20240620</td>
                </tr>

              </tbody>
              <tfoot><button className='button-upload'>Upload</button></tfoot>
            </table>

          </div>
        </div>
        <div className='bottom-grid'>
          <div className='grid-4'>
            <div className="company-License-table">
              <div className="heading">License Details</div>
              <div className='License-design'>
                <table className="table-data">
                  <thead className="License-table-head">

                    <tr>
                      <th>Ord No</th>
                      <th>License No</th>
                      <th>License Key</th>
                      <th>License Code</th>
                      <th>Valid Days</th>
                      <th>No of User License</th>
                      <th>Issue Date</th>
                      <th>Expiry Date</th>
                      <th>Authenticated to extend</th>
                      <th>Reason to extend</th>
                      <th>Status</th>
                      <th>Company Details</th>
                      <th>Payment Details</th>
                    </tr>
                  </thead>
                  <tbody className="License-table-body">

                    {licenseDetails && (
                      <tr>
                        <td>{licenseDetails.order_details[0].te_ordernumber }</td>
                        <td>{licenseDetails.te_licenseno || "N/A"}</td>
                        <td>{licenseDetails.te_lmsid || "N/A"}</td>
                        <td>{licenseDetails.te_licensecode || "N/A"}</td>
                        <td>{calculateValidDays() || "N/A"}</td>
                        <td>{licenseDetails.te_licenseusedbyusers}</td>
                        <td>{formatDate(licenseDetails.te_licenseactivationdate)}</td>
                        <td>{formatDate(licenseDetails.te_licenseexpirationdate)}</td>
                        <td>{licenseDetails.te_islicenseactivated ? 'Yes' : 'No'}</td>
                        <td>{licenseDetails.te_extendlicencedescription}</td>
                        <td>{licenseDetails.te_islicenseactivated ? 'Active' : 'Inactive'}</td>
                        {/* <td style={{ textDecoration: "underline",cursor:"pointer" }} onClick={() => { 
                      navigate('/CompanyDetails') }}>Company</td> */}
                        <td >{licenseDetails.master_company.te_companyname}</td>
                        <td  >Cheque</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Companydetails